// extracted by mini-css-extract-plugin
var _1 = "cZD1d";
var _2 = "TJtXF";
var _3 = "d5loA";
var _4 = "g5Vh8";
export { _1 as "counter", _2 as "counter--menu-dark", _3 as "counter--menu-light", _4 as "counter--primary" }
